import { QueryLayout } from "common/components/Layout/QueryLayout";
import { Title } from "common/components/Title/Title";
import { FC } from "react";
import { NavLink } from "react-router-dom";
import { useGetUseRulesQuery } from "services/appApi";

export const UseRulesPage: FC<{ applicationId: number }> = ({
  applicationId,
}) => {
  const { data, isLoading, error, isFetching } =
    useGetUseRulesQuery(applicationId);

  return (
    <section className="absolute top-0 bottom-0 left-0 right-0 z-10 flex h-full flex-col bg-white py-[20px] px-[15px]">
      <Title>Правила пользования</Title>
      <div className="mb-[15px] text-sm text-gray">
        <NavLink to="/">Главная</NavLink> / Правила пользования
      </div>
      <div className="grid gap-[15px] overflow-y-scroll rounded border border-lightWhiteGray p-[15px] leading-[17px] text-lightGray">
        <QueryLayout
          isLoading={isLoading}
          isFetching={isFetching}
          error={error}
        >
          {data?.map((rule) => (
            <p key={rule.id}>{rule.content}</p>
          ))}
        </QueryLayout>
      </div>
    </section>
  );
};
